<div class="contain">
    <label translate>data.export.selectusers</label>
    <div class="warp-serach-users">
        <input class="select" type="text" placeholder="{{'search.search' | translate}}" matInput
            [formControl]="myControl">
        <div class="custom-checkbox pointer" (click)="selectAll()">
            <div class="choose" [ngClass]="{'selected':isSelectAll$()}">
                <div class="inner-selected">
                    <img src="/assets/images/auto-fill/vi.svg">
                </div>
            </div>
            <p translate>selectAll</p>
        </div>
        <div class="scrool-users">
            <div class="custom-checkbox warp-recip pointer" (click)="onContactSelected(u)"
                *ngFor="let u of filterUsers$();let i=index">
                <div class="choose " [ngClass]="{'selected':u.selected}">
                    <div class="inner-selected">
                        <img src="/assets/images/auto-fill/vi.svg">
                    </div>
                </div>
                <que-mini-contact-display [user]="u.user" [isSelect]="true"></que-mini-contact-display>
            </div>
            <div class="no-result" *ngIf="filterUsers$()?.length==0" translate>no-result.not-found</div>
        </div>
    </div>
    <div class="">
        <label *ngIf="selectedUsers$()?.length" [translateParams]="{ num: selectedUsers$().length}"
            translate>data.export.desc</label>
    </div>
</div>